<div class="m-4">
    <form (ngSubmit)="companyDetailsFormSub()" #f="ngForm">
    <div class="row" class="font-weight-bold mb-4">
      Enter Firm Details
    </div>
        <div class="row">
          <div class="col-2 p-0">
            <label>Upload Company Logo</label>
            <p-fileUpload [disabled]="disableFields" #createUploader name="demo[]" mode="basic" chooseLabel="Browse" [auto]="true" customUpload="true" 
              (uploadHandler)="onUpload($event, createUploader)"  accept="image/*"
              invalidFileTypeMessageSummary=""
              invalidFileTypeMessageDetail="Unaccepted format. Please upload a 'png' format file"
              showUploadButton="false"
              showCancelButton="false"
              maxFileSize="10485760">
            </p-fileUpload>
          </div>
  
          <div class="col-10">
            <div style="width:20rem;height:auto">
              <img *ngIf="companyLogoImage" [src]="companyLogoImage" />
            </div>  
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-4 pl-0 ">
            <label class="required">Firm Name</label>
            <input type="text" pInputText [disabled]="disableFields"
            class="im-input" name="companyName"
            [(ngModel)]="company.companyName" placeholder="Company name" value = {{this.getCompanyNameFirst}} #companyName="ngModel" required />
              <span class="invalid-message" *ngIf="
                    (companyName.touched || f.submitted) && companyName.errors?.required
                  ">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          </div>
          <div class="col-4">
            <label>FEI Number <span *ngIf="company.incorporationLoc.countryCode === 'USA'" class="text-danger">*</span></label>
          <input type="text" [disabled]="disableFields" class="im-input" id="feiNo" name="feiNo" [(ngModel)]="company.feiNo"
            maxlength="10" minlength="9" placeholder="Enter FEI Number" #feiNo="ngModel" [required]="company.incorporationLoc.countryCode === 'USA'"
            pattern="^\d{2}\-?\d{7}$" />
          <span class="invalid-message" *ngIf="(feiNo.touched || f.submitted) && feiNo.errors?.required">
            {{ getGlobalErrorMessages("REQUIRED") }}
          </span>
          <span class="invalid-message" *ngIf="feiNo.errors?.maxlength">
            {{ getGlobalErrorMessages("MAXLENGTH") + "9" }}
          </span>
          <span class="invalid-message" *ngIf="feiNo.errors?.minlength">
            {{ getGlobalErrorMessages("MINLENGTH") + "9 Numbers" }}
          </span>
          <span class="invalid-message" *ngIf="(feiNo.touched || f.submitted) && feiNo.errors?.pattern">
            {{getGlobalErrorMessages('INVALID_FORMAT')}}
          </span>
            <small>00-0000000</small>
          </div>
        </div>
          <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
          <div class="row" class="font-weight-bold mb-4">
            Contact Details
          </div>
          <div class="row">
            <div class="col-4 pl-0"><label class="required">Office Telephone Number</label></div>
            <!-- <div class="col-4"><label class="required" >Mobile Number</label></div> -->
          </div>
          <div class="row">
            <div class="col-1 pl-0 pr-0">
              <p-dropdown [options]="listCountry" [(ngModel)]="company.phoneContact.countryCode"
                optionLabel="countryPhoneCode" placeholder="Select" class="d-block" 
                optionValue="countryCode" name="phoneCode" #phoneCode="ngModel" [disabled]="disableFields" required>
              </p-dropdown>
              <div class="invalid-message" *ngIf="
                  (phoneNo.touched || phoneCode.touched || f.submitted) && phoneCode.errors?.required
                ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </div>
            </div>
            <div class="col-3 pl-0">
              <input pInputText class="im-input" [disabled]="disableFields" name="phoneNo" maxlength="10"
                [(ngModel)]="company.phoneContact.phoneNo" type="text" form placeholder="Office" #phoneNo="ngModel" required
                pattern="\d{1,10}"
                [ngClass]="{'im-input-error':(phoneCode.touched || phoneNo.touched || f.submitted) && phoneNo.errors?.required}" />
              <span class="invalid-message" *ngIf="
                  (phoneNo.touched || f.submitted) && phoneNo.errors?.pattern
                ">
                {{ getGlobalErrorMessages("INVALID_NUMBER") }}
              </span>
              <span class="invalid-message" *ngIf="phoneNo.errors?.maxlength">
                {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
              </span>
            </div>
            <div class="col-4" style="margin-top: -34px;">
                <label class="required">Email</label>
                <input pInputText type="text" [disabled]="disableFields" class="im-input" email name="email"
                  [(ngModel)]="company.emailContact.email" placeholder="Email" #email="ngModel" required
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$"  />
                <span class="invalid-message" *ngIf="(email.touched || f.submitted) && email.errors?.required">
                  {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
                <div class="invalid-message" *ngIf="(email.touched || f.submitted) && email.errors?.pattern">
                  {{ getGlobalErrorMessages("INVALID_EMAIL") }}
                </div>
              </div>
          </div>
          <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
          <div class="row" class="font-weight-bold mb-4">
            Registered Address
          </div>
          <div class="row mt-4">
            <div class="col-6 pl-0">
              <label class="required">Address 1</label><small class="text-secondary pl-1">Ex: Street Name & Number</small>
              <input pInputText class="im-input" [disabled]="disableFields" name="addressLine"
                [(ngModel)]="company.address[0].addressLine1" type="text" placeholder="Enter" #addressLine="ngModel"
                required />
              <span class="invalid-message" *ngIf="
                      (addressLine.touched || f.submitted) && addressLine.errors?.required
                    ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
          </div>
            <div class="row mt-4">
            <div class="col-6 pl-0">
              <label>Address 2</label><small class="text-secondary pl-1">Optional</small>
              <input pInputText class="im-input" [disabled]="disableFields" name="addressLines"
                [(ngModel)]="company.address[0].addressLine2" type="text" placeholder="Enter" />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-4 pl-0">
              <label class="required">Country</label>
              <!--<mat-form-field>-->
              <p-dropdown [options]="listCountry" [(ngModel)]="company.address[0].countryCode" optionLabel="countryName"
                placeholder="Select" class="d-block" styleClass="bene-we-dropdown" optionValue="countryCode" name="addCountry"
                (onChange)="handleCountryChange(company.address[0].countryCode, 'reg')" #addCountry="ngModel" [disabled]="disableFields"
                required></p-dropdown>
      
              <!--</mat-form-field>-->
              <div class="invalid-message" *ngIf="
                        (addCountry.touched || f.submitted) && addCountry.errors?.required
                      ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </div>
            </div>
            <div class="col-4" *ngIf="listStates.length > 0">
              <label class="required">State</label>
              <!--<mat-form-field>-->
              <p-dropdown [options]="listStates" [(ngModel)]="company.address[0].stateProvinceCode"
                optionLabel="stateProvinceName" placeholder="Select" class="d-block" styleClass="bene-we-dropdown"
                optionValue="stateProvinceCode" name="addState" #addState="ngModel" [disabled]="disableFields" required>
              </p-dropdown>
              <!--</mat-form-field>-->
              <div class="invalid-message" *ngIf="
                        (addState.touched || f.submitted) && addState.errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </div>
            </div>
            <div class="col-4" *ngIf="listStates.length <= 0">
              <label >State*</label>
              <input pInputText class="im-input" [disabled]="disableFields" name="addrState"
                [(ngModel)]="company.address[0].stateProvinceName" type="text" placeholder="State" #addrState="ngModel"
                required />
              <span class="invalid-message" *ngIf="
                        (addrState.touched || f.submitted) && addrState.errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>

            <div class="col-4 pl-0">
                <label class="required">City</label>
                <input pInputText class="im-input" [disabled]="disableFields" name="addrCity" [(ngModel)]="company.address[0].city"
                  type="text" placeholder="City" #addrCity="ngModel" required />
                <span class="invalid-message" *ngIf="(addrCity.touched || f.submitted) && addrCity.errors?.required ">
                  {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
              </div> 
  
          </div>
          <div class="row mt-4">
            <div class="col-4 pl-0">
              <label>Locality</label>
              <input pInputText class="im-input" name="locality" [(ngModel)]="company.address[0].locality"
                type="text" placeholder="Locality" #locality="ngModel" />
            </div>        
            <div class="col-4">
              <label class="required">Zip Code</label>
              <input pInputText class="im-input" [disabled]="disableFields" name="addrPostCode"
                [(ngModel)]="company.address[0].postCode" type="text" placeholder="Zip Code" #addrPostCode="ngModel" required
                pattern="^$|^[A-Za-z0-9]+" maxlength="10" />
              <span class="invalid-message" *ngIf="(addrPostCode.touched || f.submitted) &&
                    addrPostCode.errors?.required">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
              <span class="invalid-message" *ngIf="(addrPostCode.touched || f.submitted) &&
                        addrPostCode.errors?.pattern">
                {{ getGlobalErrorMessages("ZIPCODE_ONLY") }}
              </span>
              <span class="invalid-message" *ngIf="addrPostCode.errors?.maxlength">
                {{ getGlobalErrorMessages("MAXLENGTH") + "10" }}
              </span>
            </div>
          </div>
          <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
          <div class="row" class="font-weight-bold mb-4">
            Mailing Address
          </div>
          <div class="col-8 pl-0">
            <p-checkbox name="isSameAddress" label="Same as Registered Address" [disabled]="disableFields" (onChange)="copyAddress($event)"
              [(ngModel)]="isSameAddress">
              
            </p-checkbox>
          </div>
          <div class="row mt-4">
            <div class="col-6 pl-0">
              <label class="required">Address 1</label><small class="text-secondary pl-1">Ex: Street Name & Number</small>
              <input pInputText class="im-input" [disabled]="disableFields" name="addressLineMail"
                [(ngModel)]="company.address[1].addressLine1" type="text" placeholder="Enter" #addressLineMail="ngModel"
                required />
              <span class="invalid-message" *ngIf="
                      (addressLineMail.touched || f.submitted) &&
                      addressLineMail.errors?.required
                    ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>
          </div>
            <div class="row mt-4">
            <div class="col-6 pl-0">
              <label >Address 2</label><small class="text-secondary pl-1">Optional</small>
              <input pInputText class="im-input" [disabled]="disableFields" name="addressLinesMail"
                [(ngModel)]="company.address[1].addressLine2" type="text" placeholder="Enter" />
            </div>
          </div>
          <div class="row mt-4">
            <div class="form-group col-4 pl-0">
              <label class="required">Country</label>
              <p-dropdown [options]="listCountry" [(ngModel)]="company.address[1].countryCode" optionLabel="countryName"
                placeholder="Select" class="d-block" styleClass="bene-we-dropdown" optionValue="countryCode"
                name="addCountryMail" (onChange)="handleCountryChange(company.address[1].countryCode, 'mail')"
                #addCountryMail="ngModel" [disabled]="disableFields" required></p-dropdown>
              <div class="invalid-message" *ngIf="
                      (addCountryMail.touched || f.submitted) &&
                      addCountryMail.errors?.required
                    ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </div>
            </div>
            <div class="col-4" *ngIf="listStatesMail.length > 0">
              <label class="required">State</label>
              <p-dropdown [options]="listStatesMail" [(ngModel)]="company.address[1].stateProvinceCode"
                optionLabel="stateProvinceName" placeholder="Select" class="d-block" styleClass="bene-we-dropdown"
                optionValue="stateProvinceCode" name="addStateMail" #addStateMail="ngModel" [disabled]="disableFields"
                required></p-dropdown>
              <div class="invalid-message" *ngIf="
                      (addStateMail.touched || f.submitted) &&
                      addStateMail.errors?.required
                    ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </div>
            </div>
            <div class="col-4" *ngIf="listStatesMail.length <= 0">
              <label class="required">State</label>
              <input pInputText class="im-input" [disabled]="disableFields" name="addrStateMail"
                [(ngModel)]="company.address[1].stateProvinceName" type="text" placeholder="State" #addrStateMail="ngModel"
                required />
              <span class="invalid-message" *ngIf="
                      (addrStateMail.touched || f.submitted) &&
                      addrStateMail.errors?.required
                    ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
            </div>

            <div class="col-4 pl-0">
                <label class="required">City</label>
                <input pInputText class="im-input" [disabled]="disableFields" name="addrCity" [(ngModel)]="company.address[1].city"
                  type="text" placeholder="City" #addrCity="ngModel" required />
                <span class="invalid-message" *ngIf="(addrCity.touched || f.submitted) && addrCity.errors?.required ">
                  {{ getGlobalErrorMessages("REQUIRED") }}
                </span>
              </div> 

          </div>
          <div class="row mt-4">
            <div class="col-4 pl-0">
              <label>Locality</label>
              <input pInputText class="im-input" name="locality" [(ngModel)]="company.address[1].locality"
                type="text" placeholder="Locality" #locality="ngModel" />
            </div>
            <div class="col-4">
              <label class="required">Zip Code</label>
              <input pInputText class="im-input" [disabled]="disableFields" name="addrPostCodeMail"
                [(ngModel)]="company.address[1].postCode" type="text" placeholder="Zip Code" #addrPostCodeMail="ngModel"
                required pattern="^$|^[A-Za-z0-9]+" maxlength="10" />
              <span class="invalid-message" *ngIf="
                      (addrPostCodeMail.touched || f.submitted) &&
                      addrPostCodeMail.errors?.required
                    ">
                {{ getGlobalErrorMessages("REQUIRED") }}
              </span>
              <span class="invalid-message" *ngIf="
                      (addrPostCodeMail.touched || f.submitted) &&
                      addrPostCodeMail.errors?.pattern
                    ">
                {{ getGlobalErrorMessages("INVALID_NUMBER") }}
              </span>
              <span class="invalid-message" *ngIf="addrPostCodeMail.errors?.maxlength">
                {{ getGlobalErrorMessages("MAXLENGTH") + "7" }}
              </span>
            </div>
          </div>
          <hr style="border-top:1px dashed rgba(0, 0, 0, 0.1)!important" class="my-4" />
          <div class="row">
            <div class="col-6"></div>
            <div class="col text-right">
              <button (click)="onCancel()" pButton type="button" class="align-top mr-4 p-button-secondary">
                Cancel
              </button>
              <div class="border-right d-inline-block mr-4" style="height:46px"></div>
              <button type="submit" [disabled]="f.invalid||disableFields"  class="im-btn im-btn-primary im-btn-md">
                Next
              </button>
            </div>
          </div>
        </form>
        </div>
        